import axios from 'axios';

const Axios = axios.create();

Axios.defaults.headers.common['X-CSRF-TOKEN'] = window.Evat.data.csrfToken;
Axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

Axios.interceptors.response.use(
    function (response) {
        if (response.data) {
            response = response.data;
        }

        return response;
    },
    function (error) {

        return Promise.reject(error)
    }
);

export default Axios;
